import { render, staticRenderFns } from "./SmsApprove.vue?vue&type=template&id=be0cc816&scoped=true&"
import script from "./SmsApprove.vue?vue&type=script&lang=js&"
export * from "./SmsApprove.vue?vue&type=script&lang=js&"
import style0 from "./SmsApprove.vue?vue&type=style&index=0&id=be0cc816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0cc816",
  null
  
)

export default component.exports